import React, { useState, createContext, useContext } from 'react';
import { BrowserRouter, Routes, Route, Navigate, NavLink, useNavigate } from 'react-router-dom';
import './index.css';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import InstancePage from './pages/InstancePage';
import Reports from './pages/Reports';

export const AuthContext = createContext(null);

function ChartIcon() {
  return (
    <svg width="28" height="28" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="32" height="32" rx="8" fill="#4f6ef7"/>
      <polyline points="4,22 10,14 16,18 22,10 28,6" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
      <circle cx="28" cy="6" r="2.5" fill="#12b76a"/>
    </svg>
  );
}

function Navbar() {
  const { user, logout } = useContext(AuthContext);
  if (!user) return null;
  const initial = user.username ? user.username[0].toUpperCase() : '?';
  return (
    <>
      <nav className="navbar">
        <div className="navbar-brand">
          <ChartIcon />
          <span className="brand-text">Invest<span className="brand-accent">Track</span></span>
        </div>
        <div className="navbar-user-area">
          <div className="user-avatar" title={user.username}>{initial}</div>
          <button className="btn-logout" onClick={logout}>התנתק</button>
        </div>
      </nav>
      <nav className="bottom-nav">
        <NavLink to="/dashboard" className={({ isActive }) => 'bottom-nav-item' + (isActive ? ' active' : '')}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/></svg>
          <span>דשבורד</span>
        </NavLink>
        <NavLink to="/reports" className={({ isActive }) => 'bottom-nav-item' + (isActive ? ' active' : '')}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/></svg>
          <span>דוחות</span>
        </NavLink>
      </nav>
    </>
  );
}

function App() {
  const [user, setUser] = useState(() => {
    const token = localStorage.getItem('token');
    const username = localStorage.getItem('username');
    return token ? { token, username } : null;
  });

  const login = (data) => {
    localStorage.setItem('token', data.token);
    localStorage.setItem('username', data.username);
    setUser(data);
  };

  const logout = () => {
    localStorage.clear();
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      <BrowserRouter>
        <div className="app">
          <Navbar />
          <Routes>
            <Route path="/login" element={!user ? <Login /> : <Navigate to="/dashboard" />} />
            <Route path="/register" element={!user ? <Register /> : <Navigate to="/dashboard" />} />
            <Route path="/dashboard" element={user ? <Dashboard /> : <Navigate to="/login" />} />
            <Route path="/instances/:id" element={user ? <InstancePage /> : <Navigate to="/login" />} />
            <Route path="/reports" element={user ? <Reports /> : <Navigate to="/login" />} />
            <Route path="*" element={<Navigate to={user ? "/dashboard" : "/login"} />} />
          </Routes>
        </div>
      </BrowserRouter>
    </AuthContext.Provider>
  );
}

export default App;
